import orderBy from 'lodash/orderBy';
import type { AspectRatio } from '~/Partials/Picture/AspectRatios';

interface AllowedRatio {
    name: AspectRatio;
    value: number;
}

const allowedRatios: AllowedRatio[] = [
    { name: '1x1', value: 1 },
    { name: '2x3', value: 2 / 3 },
    { name: '3x2', value: 3 / 2 },
    { name: '3x4', value: 3 / 4 },
    { name: '4x3', value: 4 / 3 },
    { name: '9x16', value: 9 / 16 },
    { name: '16x9', value: 16 / 9 },
];

const sortedRatios = orderBy(allowedRatios, ratio => ratio.value);

export const resolveAspectRatio = (width: number | undefined, height: number | undefined): AspectRatio | undefined => {
    if (!width || !height) {
        return undefined;
    }

    const ratio = width / height;

    let previous: AllowedRatio | null = null;

    for (const potentialRatio of sortedRatios) {
        if (potentialRatio.value > ratio) {
            if (!previous) {
                return potentialRatio.name;
            }

            return potentialRatio.value - ratio > ratio - previous.value ? previous.name : potentialRatio.name;
        }

        previous = potentialRatio;
    }

    return previous?.name;
};
